/**
 * Deep link do painel de notificações (DEV-877).
 *
 * O e-mail de movimentação de equipe traz dois links no rodapé — "escolher o que receber" e
 * "cancelar estes avisos" — e os dois apontam para a home do app do destinatário com esta query:
 * `/app?notificacoes=preferencias` (Plataforma) e `/admin?notificacoes=preferencias` (Admin). Os
 * caminhos vivem em `Notifications:Email:PreferencesPathByApp`, no `sharedsettings.json` do
 * backend-v3 — mudar o nome do parâmetro aqui exige mudar lá, na mesma entrega.
 *
 * Não existe endpoint de cancelamento por clique: "cancelar estes avisos" é a mesma tela de
 * preferências, e é a pessoa que desliga o canal.
 */

/** Nome do parâmetro. pt-BR, como o resto dos query params do produto (`atribuicao`, `source`). */
export const NOTIFICATIONS_QUERY_PARAM = "notificacoes";

/** Único valor reconhecido hoje: abre o painel já na vista de preferências. */
export const NOTIFICATIONS_QUERY_PREFERENCES = "preferencias";
